export class GetCompaniesPimsModel {
  transporterId!: number;
  transporterName!: string;
  transporterCnpj!: string;
  active!: boolean;
  checked: boolean = false;
}
